module.exports = __webpack_public_path__ + "img/slider-background.6b359b24.jpg";